import { Injectable } from '@angular/core';
import { CostObjectModel } from '../../../../core/models/misc/costObject.model';
import { HttpService } from '../http-service/http.service';
import { Observable } from 'rxjs';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export class CostObjectService {
    constructor(private httpService: HttpService<CostObjectModel>) {}

    getCostObjects(): Observable<CostObjectModel[]> {
        return this.httpService.getList('/assets/costObjects.json');
    }
}
